import { Button } from '@casumo/dojo-react';
import { memo } from 'react';
import useAreRequiredFieldsFilled from '../../hooks/useAreRequiredFieldsFilled.tsx';
import useFieldValidator from '../../hooks/useFieldValidator.tsx';
import { useFlowContext } from '../../hooks/useFlowContext.tsx';
import useFlowNavigation from '../../hooks/useFlowNavigation.tsx';
import useMarketInfo from '../../hooks/useMarketInfo.tsx';
import { useRegistrationStore } from '../../store/store.ts';
import { TEST_ID } from '../../utils/constants.ts';

type TAdressButton = {
  handleNext: ({ gtmPayload, redirectTo }: {
    gtmPayload?: Record<string, string>;
    redirectTo?: string;
    canProceed?: boolean;
  }) => void;
  label?: string;
  gtmPayload?: Record<string, string>;
}

const AddressButton = ({ label,gtmPayload, handleNext }: TAdressButton) => {
  const { formData, setCondition, conditions } = useRegistrationStore();
  const { config } = useFlowContext();
  const marketInfo = useMarketInfo();
  const { validateAllFields } = useFieldValidator(config);
  const { step } = useFlowNavigation(marketInfo, config);
  const currentStepConfig = config.steps[step]
  const isNextEnabled = useAreRequiredFieldsFilled(formData, currentStepConfig);

  const handleClick = () => {
  
    if (conditions?.enterAddressManually !== true) {
      setCondition('enterAddressManually', true);
      if(!isNextEnabled) {
        validateAllFields()
      }
    } else {
      if (isNextEnabled) {
        handleNext({ gtmPayload, redirectTo: '1' });
      } else {
        validateAllFields();
      }
    }
  
  };

  return (
    <Button 
      className="focus:outline-none focus:ring-purpleblue focus:ring-offset-0 focus:ring-0.5"
      width="full"
      onClick={handleClick}
      data-testid={TEST_ID.BUTTON_PRIMARY}
    >
      {label}
    </Button>
  )
};

const Memoized = memo(AddressButton);
Memoized.displayName = 'AddressButton';

export default Memoized;
